module.exports = __webpack_public_path__ + "img/role_3.909023a5.png";